import React from 'react';

const Sustainability = () => {
  const stats = [
    { val: '100%', label: 'Local Sourcing' },
    { val: 'Zero', label: 'Single Plastic' },
    { val: '85%', label: 'Tribal Staff' },
    { val: 'Eco', label: 'Sustainability' }
  ];

  return (
    <section id="about" className="section-padding bg-emerald-900 text-white relative matter-pattern overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
        <div className="order-2 md:order-1 px-4 md:px-0">
          <span className="text-emerald-400 font-bold uppercase tracking-[0.3em] text-[10px] md:text-xs">Our Commitment</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-4 serif italic leading-tight">Preserving Nature,<br/>Empowering People.</h2>
          <div className="w-12 md:w-16 h-1 bg-emerald-500 my-6 md:my-8"></div>
          <p className="text-emerald-100/70 text-sm md:text-lg leading-relaxed mb-8 md:mb-10 italic font-poppins">
            Jaladhara is more than just a destination; it is a promise. We operate with a "Nature-First" philosophy, ensuring that every guest experience contributes to the conservation of the Maredumilli forest and its tribal heritage.
          </p>
          <div className="grid grid-cols-2 gap-4 md:gap-8">
            {stats.map((stat, idx) => (
              <div key={idx} className="flex flex-col gap-1">
                <div className="text-emerald-400 text-2xl md:text-3xl font-bold">{stat.val}</div>
                <div className="text-[10px] uppercase tracking-widest font-bold opacity-60">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="order-1 md:order-2 p-4">
          <div className="relative">
            <div className="absolute inset-0 border-2 border-emerald-500 rounded-[30px] md:rounded-[50px] translate-x-3 translate-y-3"></div>
            <img src="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Sustainability" className="relative z-10 rounded-[30px] md:rounded-[50px] w-full h-64 md:h-[500px] object-cover shadow-3xl hover:scale-105 transition duration-700" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sustainability;
